<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Pagamento </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol sm="4">
                  <CInput
                    disabled
                    label="Meio de Pagamento"
                    v-model="form.meio_pagamento"/>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="email"
                    rules="required|max:50"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Email"
                      type="email"
                      valid-feedback
                      autocomplete="email"
                      v-model="form.login"
                      :invalid-feedback="errors[0]"
                      placeholder="Digite o e-mail de acesso"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="senha"
                    rules="required|max:50"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Senha"
                      valid-feedback
                      v-model="form.senha"
                      :invalid-feedback="errors[0]"
                      placeholder="Digite a senha de acesso"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="4">
                  <validation-provider
                    name="parcelamento"
                    rules="required|max:2"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="number"
                      append="vezes"
                      valid-feedback
                      placeholder="5"
                      label="Parcelamento"
                      :invalid-feedback="errors[0]"
                      v-model="form.parcelamento"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="parcela mínima"
                    rules="required|max:4"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="number"
                      prepend="R$"
                      valid-feedback
                      placeholder="20,00"
                      label="Parcela Mínima"
                      :invalid-feedback="errors[0]"
                      v-model="form.parcela_minima"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="validade boletos"
                    rules="required|max:2"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="number"
                      append="dias"
                      valid-feedback
                      placeholder="2"
                      label="Validade Boletos"
                      :invalid-feedback="errors[0]"
                      v-model="form.validade_boletos"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name:'paymentForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.pagamento
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.pagamento 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'pagamento')
        }
      }
    },
    methods: {
      ...mapActions(['savePagamento', 'updatePayment']),
      save() {
        this.savePagamento(this.form);
      },
      update() {
        this.updatePayment(this.form)
      }
    }
  }
</script>
